<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Inland Cost</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="inland_cost" type="text" placeholder="Inland cost" :class="{ 'is-danger': errors.inland_cost }">
                    <span class="icon is-left">
                        <i class="fas fa-truck"></i>
                    </span>
                    <p v-if="errors.inland_cost" class="help is-danger">{{ errors.inland_cost[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            inland_cost: {
                get() {
                    return this.$store.getters.getNewPricePlan.inland_cost
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'inland_cost', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/InlandCostInput.vue